import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'keycom-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit {
  @Input() breadcrumb

  constructor() {}

  ngOnInit() {}
}
